/**
 * Convierte una fecha a string en formato YYYY-MM-DD
 */
export const getLocalDateString = (date: Date = new Date()): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

/**
 * Convierte un string YYYY-MM-DD a objeto Date
 */
export const parseLocalDate = (dateString: string): Date => {
  if (!dateString) return new Date();
  const [year, month, day] = dateString.split('-').map(Number);
  return new Date(year, month - 1, day);
};

/**
 * Obtiene el inicio de la semana local (lunes)
 */
export const getWeekStartDate = (date: Date): Date => {
  const day = date.getDay();
  const diff = (day + 6) % 7;
  const start = new Date(date);
  start.setDate(date.getDate() - diff);
  start.setHours(0, 0, 0, 0);
  return start;
};

/**
 * Obtiene el fin de la semana local (domingo)
 */
export const getWeekEndDate = (date: Date): Date => {
  const end = getWeekStartDate(date);
  end.setDate(end.getDate() + 6);
  end.setHours(23, 59, 59, 999);
  return end;
};

/**
 * Calcula la semana del plan usando semanas calendario que empiezan el lunes.
 * Si el plan empieza a mitad de semana, la semana 1 termina el domingo de esa semana.
 */
export const getTrainingPlanWeekNumber = (
  startDate: Date,
  referenceDate: Date = new Date()
): number => {
  const planWeekStart = getWeekStartDate(startDate);
  const referenceWeekStart = getWeekStartDate(referenceDate);
  const millisecondsPerWeek = 1000 * 60 * 60 * 24 * 7;
  const weeksDiff = Math.floor(
    (referenceWeekStart.getTime() - planWeekStart.getTime()) / millisecondsPerWeek
  );

  return Math.max(1, weeksDiff + 1);
};

/**
 * Verifica si una fecha es hoy
 */
export const isToday = (date: Date): boolean => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};
